import React, { useState, useRef, useEffect } from 'react';
import VideoCard from './VideoCard';
import './VideoFeed.css';

function VideoFeed({ snippets }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    setCurrentIndex(0);
    if (containerRef.current) {
      containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [snippets]);

  const handleScroll = (e) => {
    const scrollTop = e.target.scrollTop;
    const windowHeight = e.target.clientHeight;
    const newIndex = Math.round(scrollTop / windowHeight);
    
    if (newIndex !== currentIndex && newIndex >= 0 && newIndex < snippets.length) {
      setCurrentIndex(newIndex);
    }
  };

  if (!snippets || snippets.length === 0) {
    return (
      <div className="no-snippets">
        <p>No coaching moments found for this recording.</p>
      </div>
    );
  }

  return (
    <div 
      className="video-feed" 
      ref={containerRef}
      onScroll={handleScroll}
    >
      {snippets.map((snippet, index) => (
        <VideoCard 
          key={index}
          snippet={snippet}
          isActive={index === currentIndex}
        />
      ))}
    </div>
  );
}

export default VideoFeed;
